import { useMemo, useCallback, useState } from "react";
import { config } from "node-config-ts";
import { useHotkeys } from "react-hotkeys-hook";
import styles from "./app-version.less";

type AppVersionProps = {
    showFullText: boolean;
};

export const AppVersion = (props: AppVersionProps) => {
    const { showFullText } = props;
    const version = process.env.REACT_APP_VERSION;
    const [displayAppVersion, setDisplayAppVersion] = useState([
        "local",
        "dev",
        "test",
        "qa1",
        "qa2"
    ].includes(config.APPLICATION_ENVIRONMENT));

    const handleHotKeyPressed = useCallback(() => {
        setDisplayAppVersion(prevDisplayAppVersion => !prevDisplayAppVersion)
    }, [displayAppVersion]);

    useHotkeys("ctrl+shift+k, command+shift+k", handleHotKeyPressed);

    const text = useMemo(() => {
        return `${showFullText ? "Admin UI " : ""}v${version}`;
    }, [showFullText, version]);

    return displayAppVersion
        ? <div className={showFullText ? styles.appVersion : styles.appVersionShort}>{text}</div>
        : null
};